import { SidenavItemType } from './SidenavItemTypes';
import { PERMISSIONS } from '../../constants';

const SidenavItems: SidenavItemType[] = [
  {
    ActivePaths: ['users'],
    Permissions: [PERMISSIONS.UserModify],
    Icon: 'people',
    Name: 'Käyttäjät',
    SubItems: [
      {
        Name: 'Käyttäjät haku',
        Url: '/users/search',
      },
    ],
  },
  {
    ActivePaths: ['bookings'],
    Permissions: [PERMISSIONS.BookingModify],
    Icon: 'activity',
    Name: 'Varaustilanne',
    TranslationKey: 'availability',
    SubItems: [
      {
        Name: 'Varaa majoitus',
        TranslationKey: 'searchAccommodations',
        Url: '/bookings/search-accommodations',
      },
      {
        Name: 'Varaukset',
        TranslationKey: 'searchBookings',
        Url: '/bookings/search-bookings',
      },
    ],
  },
  {
    ActivePaths: ['customers'],
    Permissions: [PERMISSIONS.UserModify],
    Icon: 'grid',
    Name: 'Asiakkaat ja ryhmät',
    Url: '/customers/search',
    SubItems: [
      {
        Name: 'Asiakkaat haku',
        Url: '/customers/search',
      },
      {
        Name: 'Asiakasryhmät',
        Url: '/customers/customergroups',
      },
    ],
  },
  {
    ActivePaths: ['accommodations'],
    Permissions: [PERMISSIONS.AccommodationModify],
    Icon: 'house',
    Name: 'Majoitukset ja ryhmät',
    SubItems: [
      {
        Name: 'Majoitukset',
        Url: '/accommodations/search',
      },
      {
        Name: 'Majoitusryhmät',
        Url: '/accommodations/accommodationgroups',
      },
      {
        Name: 'Majoitusten varustelut',
        Url: '/accommodations/accommodationattributes',
      },
      {
        Name: 'Lisäpalveluiden määritykset',
        Url: '/accommodations/addondefinitions',
      },
      {
        Name: 'Hintaryhmä tagit',
        Url: '/accommodations/tags',
      },
      {
        Name: 'Edustajaraportti',
        Url: '/accounting/agentreport',
      },
      {
        Name: 'Tilitysraportti',
        Url: '/accounting/settlementreport',
      },
      {
        Name: 'Omistajaraportti',
        Url: '/accounting/ownerreport',
      },
    ],
  },
  {
    ActivePaths: ['feedbacks'],
    Permissions: [PERMISSIONS.CustomerFeedbackModify],
    Icon: 'emoji-smile',
    Name: 'Palautteet',
    Url: '/feedbacks/search',
  },
  {
    ActivePaths: ['pricing'],
    Permissions: [PERMISSIONS.PricingModify],
    Icon: 'currency-euro',
    Name: 'Hinnoittelu',
    SubItems: [
      {
        Name: 'Oletushintakaudet',
        Url: '/rates/defaultrates',
      },
      {
        Name: 'Sesonkihintakaudet',
        Url: '/rates/seasonrates',
      },
      {
        Name: 'Estetyt jaksot',
        Url: '/rates/blockedperiods',
      },
      {
        Name: 'Hintakausien kopiointi',
        Url: '/rates/ratetools/copyseasonrates',
      },
      {
        Name: 'Hintojen korotus ja alennus',
        Url: '/rates/ratetools/changeseasonrateprices',
      },
      {
        Name: 'Hintakauden päivämäärät',
        Url: '/rates/ratetools/modifyseasonratestool',
      },
      {
        Name: 'Lisäpalvelusäännöt',
        Url: '/rates/ratetools/modifyaddonrulestool',
      },
    ],
  },
  {
    ActivePaths: ['locations'],
    Permissions: [PERMISSIONS.LocationModify],
    Icon: 'pin-map',
    Name: 'Sijaintitiedot',
    SubItems: [
      {
        Name: 'Maat',
        Url: '/locations/countries',
      },
      {
        Name: 'Alueet',
        Url: '/locations/regions',
      },
      {
        Name: 'Kunnat',
        Url: '/locations/municipalities',
      },
      {
        Name: 'Paikat',
        Url: '/locations/places',
      },
      {
        Name: 'Hiihtokeskukset',
        Url: '/locations/skiresorts',
      },
    ],
  },
  /*
  {
    ActivePaths: ['settings'],
    Permissions: [PERMISSIONS.SettingRead],
    Icon: 'sliders',
    Name: 'Asetukset',
    SubItems: [
      {
        Name: 'Varaamot',
        Url: '/settings/offices',
      },
      {
        Name: 'Lokitiedot',
        Url: '/settings/auditlogs',
      },
    ],
  },
  */
  {
    ActivePaths: ['accounting'],
    Permissions: [PERMISSIONS.FinancialModify],
    Icon: 'paperclip',
    Name: 'Taloushallinto',
    SubItems: [
      {
        Name: 'Myynti Alv määritykset',
        Url: '/accounting/sellvats',
      },
      {
        Name: 'Osto Alv määritykset',
        Url: '/accounting/purchasevats',
      },
      {
        Name: 'Myynti Kirjanpitotilit',
        Url: '/accounting/sellaccountinggroups',
      },
      {
        Name: 'Osto Kirjanpitotilit',
        Url: '/accounting/purchaseaccountinggroups',
      },
      {
        Name: 'Kirjanpitoaineiston siirto Wintimeen',
        Url: '/accounting/generateandsendaccountingdata',
      },
      {
        Name: 'Koontitilastot',
        Url: '/accounting/salesstatistics',
      },
      {
        Name: 'Myyntikirja',
        Url: '/accounting/sellstats',
      },
      {
        Name: 'Ennakkomyynit kirjanpitotileittäin',
        Url: '/accounting/presellstats',
      },
      {
        Name: 'Matkatoimisto raportti',
        Url: '/accounting/travelagencyreport',
      },
      {
        Name: 'InterHome raportti',
        Url: '/accounting/interhomereport',
      },
      {
        Name: 'DAC7 raportti',
        Url: '/accounting/dac7reports',
      },
      {
        Name: 'Laskuarkisto',
        Url: '/accounting/Invoices',
      },
    ],
  },
  {
    ActivePaths: ['accounting'],
    Permissions: [PERMISSIONS.TravelAgencyDomainUser],
    Icon: 'paperclip',
    Name: 'Matkan järj. Taloushallinto',
    SubItems: [
      {
        Name: 'Matkatoimisto raportti',
        Url: '/accounting/travelagencyreport',
      },
    ],
  },
  /*
  {
    ActivePaths: ['cart'],
    Icon: 'cart',
    Name: 'Tarjouskori',
    Url: '/cart/search',
  },
  {
    ActivePaths: ['statistics'],
    Icon: 'pie-chart',
    Name: 'Tilastot',
    Url: '/statistics',
  },
  */
];

export default SidenavItems;
export { SidenavItems };
